import { get, post } from "./api";

export const getTicketsByEventSlug = (slug: string) => {
  return get("api/v2/tickets", { slug });
};

export const getStripeCheckoutSession = (params: { ticket_types: any }) => {
  return post("api/v2/tickets/checkout_session", params);
};

export const getTicketPurchase = (id: string) => {
  return get("api/v2/tickets/ticket_purchase", { id });
};

export const createTicketPurchase = (sessionId: string, cookie?: any) => {
  return post("api/v2/tickets/payment_success", { session_id: sessionId }, cookie);
};
